import { Component, OnInit, ElementRef, Input, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Colors } from '../../../models/enums/colors.enum';
import { HttpService } from '../../../services/http.service';
import { ISubscription } from 'rxjs/Subscription';
declare var $: any;

@Component({
  selector: 'app-circle',
  templateUrl: './circle.component.html',
  styleUrls: ['./circle.component.scss']
})
export class CircleComponent implements OnInit, OnDestroy {
  @ViewChild('circle') el: ElementRef;
  @Input() percentage: number;
  @Input() innerFull: boolean = false;
  @Input() innerColor: string = Colors.lightBlue;
  @Input() colorFrom: string = Colors.red;
  @Input() colorTo: string = Colors.red;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() size: number = 50;
  @Input() isExclamation: boolean = false;

  @Input() systemId: string;
  @Input() subSystemId: string = null;
  @Input() min: number = 0;
  @Input() max: number = 100;

  subscription: ISubscription;

  constructor(private http: HttpService, private cdref: ChangeDetectorRef) { }

  ngAfterViewInit() {
    if (!this.isExclamation) {
      $(this.el.nativeElement).circleProgress({
        value: this.percentage / 100,
        size: this.size,
        startAngle: -Math.PI / 2,
        lineCap: 'round',
        fill: {
          gradient: [this.colorFrom, this.colorTo]
        }
      });
      
      this.subscription = this.http.dashboardData().subscribe(data => {
        let filtered = data.filter(sys => sys.systemId == this.systemId && sys.subSystemId == this.subSystemId);
        if (filtered.length > 0){
          let current = this.percentage;
          this.percentage = this.clip(filtered[0].value, this.min, this.max);
          if (this.percentage != current){
            this.cdref.detectChanges(); 
            this.updateProgress(this.percentage);
          }
        }
      });
    }
  }

  updateProgress(progress) {
    let val = progress / 100;
    $(this.el.nativeElement).circleProgress('value', val);
  }

  clip(value, min, max){
    let res = value;
    if (value < min) res = min;
    if (value > max) res = max;
    return res;
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/stats/circle/circle.component.ts